import { render } from "./PdfTemplates.vue?vue&type=template&id=a3136462&ts=true"
import script from "./PdfTemplates.vue?vue&type=script&lang=ts"
export * from "./PdfTemplates.vue?vue&type=script&lang=ts"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__